import React, { Component }  from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'

let select = (state, props) => ({
})

export default class Header extends Component{
	render(){
		return(
			<header
				style={{
					height: "60px"
				  , backgroundColor: "#35ba9a"
				  , margin: "0"
				  , borderBottom: "1px solid rgb(225, 227, 226)"
				  , padding: "0"
				  , display: "flex"
				  , justifyContent: "space-between"
				}}
			>
				<div
					style={{
						display: "flex"
					}}
				>
					{this.props.children[0]}
					{this.props.children[1]}
				</div>
				<div
					style={{
						margin: "18px 25px 0 0"
					}}
				>
					{this.props.children[2]}
				</div>
			</header>
		)}
}



// WEBPACK FOOTER //
// ./src/components/Header.js